import {
  RecurrenceScheduleDate,
  RecurrenceScheduleDateStatus
} from "@wingspanhq/wingspan-api-sdk";
import { getExactCutOffDate } from "../../Invoices/utils/payables";

/**
 * The payer's next contractor payroll run, read from the pay dates the cadence
 * resource projects on `PayrollSchedule.scheduleDates`.
 *
 * Two details differ from the v1 `getNextPayroll` this replaces:
 *
 * - **Statuses are excluded, not required.** `status` is optional on a v3
 *   schedule date, so requiring `Pending`/`Modified` would drop every run on a
 *   schedule that omits the field — the same silent nothing this is meant to
 *   fix. `Skipped` was opted out and `Completed` has already run; anything else,
 *   including an absent status, is upcoming.
 * - **`cutOffDate` is optional too,** so a run returned without one falls back
 *   to its pay date to decide whether it is still ahead, matching the upcoming
 *   runs table on the payroll settings screen.
 *
 * Sorted by pay date rather than trusting array order, so the run returned here
 * is the same one that table lists first.
 */
export const selectorNextPayrollScheduleDate = (
  scheduleDates: Array<RecurrenceScheduleDate> | undefined
): RecurrenceScheduleDate | undefined => {
  const now = new Date();

  return (scheduleDates || [])
    .filter(
      scheduleDate =>
        scheduleDate.status !== RecurrenceScheduleDateStatus.SKIPPED &&
        scheduleDate.status !== RecurrenceScheduleDateStatus.COMPLETED &&
        (scheduleDate.cutOffDate
          ? getExactCutOffDate(scheduleDate.cutOffDate)
          : scheduleDate.date) > now
    )
    .sort((a, b) => a.date.getTime() - b.date.getTime())[0];
};
